export const relativeIncidentUrl = (incident) => `/incidents/${incident.id}`;

export default relativeIncidentUrl